import { ElementRef, inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as d3 from 'd3';

@Injectable({
  providedIn: 'root',
})
export class ChartsService {
  private translate = inject(TranslateService);

  renderDonutChart(
    data: Record<string, number>,
    keysData: string[],
    colorsMap: Map<string, string>,
    chartContainer: ElementRef,
    text: string,
    totalText: string,
    svg: d3.Selection<SVGGElement, unknown, null, undefined> | undefined,
    width = 455,
    height = 455,
  ) {
    const radius = Math.min(width, height) / 2;

    if (svg) {
      svg.remove();
      chartContainer.nativeElement.innerHTML = '';
    }
    const color = d3
      .scaleOrdinal<string>()
      .domain([...keysData])
      .range([
        ...keysData.map((key) => {
          return colorsMap.get(key) as string;
        }),
      ]);

    const newSvg = d3
      .select(chartContainer.nativeElement)
      .append('svg')
      .attr('width', width)
      .attr('height', height)
      .append('g')
      .attr('transform', `translate(${width / 2}, ${height / 2})`);

    const pie = d3
      .pie()
      .sort(null)
      .value((d) => {
        const total = Object.values(data).reduce((acc: number, curr: number) => acc + curr, 0) as number;
        return (d as number) / total;
      });

    const arc = d3
      .arc<d3.PieArcDatum<unknown>>()
      .innerRadius(radius * 0.57)
      .outerRadius(radius * 0.8);

    const arcs = newSvg
      .selectAll('arc')
      .data(pie(Object.entries(data).map(([_, value]) => value)))
      .enter()
      .append('g')
      .attr('class', 'arc')
      .on('mouseover', function () {
        d3.select(this).transition().duration(200).attr('transform', `scale(1.05)`);
      })
      .on('mouseout', function () {
        d3.select(this).transition().duration(200).attr('transform', `scale(1)`);
      });

    arcs
      .append('path')
      .attr('d', arc)
      .attr('fill', (d, i) => color(i + ''));

    newSvg.append('text').attr('text-anchor', 'middle').attr('font-size', '14').attr('font-weight', 'bold').text(text);

    newSvg
      .append('text')
      .attr('text-anchor', 'middle')
      .attr('font-size', '24px')
      .attr('font-weight', 'bold')
      .attr('dy', '1.2em')
      .text(totalText);

    return newSvg;
  }
}
